window.addEventListener('DOMContentLoaded', () => {
	const locale = document.getElementsByTagName('html')[0]
		.getAttribute('lang')
		.split('-')[0];
	i18nParsley(locale);
});

const i18nParsley = (locale) => {
	switch (locale) {
		case 'en':
			break;
		case 'es':
			window.Parsley.addMessages('es', {
				defaultMessage: "Este valor parece ser inválido.",
				type: {
					email:        "Este valor debe ser un correo válido.",
					url:          "Este valor debe ser una URL válida.",
					number:       "Este valor debe ser un número válido.",
					integer:      "Este valor debe ser un número válido.",
					digits:       "Este valor debe ser un dígito válido.",
					alphanum:     "Este valor debe ser alfanumérico."
				},
				notblank:       "Este valor no debe estar en blanco.",
				required:       "Este valor es requerido.",
				pattern:        "Este valor es incorrecto.",
				min:            "Este valor no debe ser menor que %s.",
				max:            "Este valor no debe ser mayor que %s.",
				range:          "Este valor debe estar entre %s y %s.",
				minlength:      "Este valor es muy corto. La longitud mínima es de %s caracteres.",
				maxlength:      "Este valor es muy largo. La longitud máxima es de %s caracteres.",
				length:         "La longitud de este valor debe estar entre %s y %s caracteres.",
				mincheck:       "Debe seleccionar al menos %s opciones.",
				maxcheck:       "Debe seleccionar %s opciones o menos.",
				check:          "Debe seleccionar entre %s y %s opciones.",
				equalto:        "Este valor debe ser idéntico."
			});

			window.Parsley.setLocale('es');

			break;
		case 'fr':
			window.Parsley.addMessages('fr', {
				defaultMessage: "Cette valeur semble non valide.",
				type: {
					email:        "Cette valeur n'est pas une adresse email valide.",
					url:          "Cette valeur n'est pas une URL valide.",
					number:       "Cette valeur doit être un nombre.",
					integer:      "Cette valeur doit être un entier.",
					digits:       "Cette valeur doit être numérique.",
					alphanum:     "Cette valeur doit être alphanumérique."
				},
				notblank:       "Cette valeur ne peut pas être vide.",
				required:       "Ce champ est requis.",
				pattern:        "Cette valeur semble non valide.",
				min:            "Cette valeur ne doit pas être inférieure à %s.",
				max:            "Cette valeur ne doit pas excéder %s.",
				range:          "Cette valeur doit être comprise entre %s et %s.",
				minlength:      "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
				maxlength:      "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
				length:         "Cette valeur doit contenir entre %s et %s caractères.",
				mincheck:       "Vous devez sélectionner au moins %s choix.",
				maxcheck:       "Vous devez sélectionner %s choix maximum.",
				check:          "Vous devez sélectionner entre %s et %s choix.",
				equalto:        "Cette valeur devrait être identique."
			});

			window.Parsley.setLocale('fr');

			break;
		case 'ar':
			window.Parsley.addMessages('ar', {
				defaultMessage: "تأكد من صحة القيمة المدخل",
				type: {
					email:        "تأكد من إدخال بريد الكتروني صحيح",
					url:          "تأكد من إدخال رابط صحيح",
					number:       "تأكد من إدخال رقم",
					integer:      "تأكد من إدخال عدد صحيح بدون كسور",
					digits:       "تأكد من إدخال رقم",
					alphanum:     "تأكد من إدخال حروف وأرقام فقط"
				},
				notblank:       "تأكد من تعبئة الحقل",
				required:       "هذا الحقل مطلوب",
				pattern:        "القيمة المدخلة غير صحيحة",
				min:            "القيمة المدخلة يجب أن تكون أكبر من %s.",
				max:            "القيمة المدخلة يجب أن تكون أصغر من %s.",
				range:          "القيمة المدخلة يجب أن تكون بين %s و %s.",
				minlength:      "القيمة المدخلة قصيرة جداً . تأكد من إدخال %s حرف أو أكثر",
				maxlength:      "القيمة المدخلة طويلة . تأكد من إدخال %s حرف أو أقل",
				length:         "القيمة المدخلة غير صحيحة. تأكد من إدخال بين  %s و %s خانة",
				mincheck:       "يجب اختيار %s خيار على الأقل.",
				maxcheck:       "يجب اختيار%s خيار أو أقل",
				check:          "يجب اختيار بين %s و %s خيار.",
				equalto:        "تأكد من تطابق القيمتين المدخلة."
			});

			window.Parsley.setLocale('ar');

			break;
	}
}
